import { useModal } from '@ebay/nice-modal-react';
import { ParseKeys } from 'i18next';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { UploadTypeSelectionModal } from './UploadTypeSelectionModal';
import S from './UploadTypeSelectionModal.module.scss';
const UploadTypeSelectionCard = (props: UploadTypeSelectionCardProps) => {
  const {
    type,
    titleKey
  } = props;
  const {
    hide
  } = useModal(UploadTypeSelectionModal);
  const {
    t
  } = useTranslation(['store']);
  return <div className={S.card_wrapper} onClick={() => {
    logger.track('store_upload_select', {
      type
    });
    hide();
  }} data-sentry-component="UploadTypeSelectionCard" data-sentry-source-file="UploadTypeSelectionCard.tsx">
      <Link href={`/store/upload?type=${type}`} passHref={true} prefetch={false} data-sentry-element="Link" data-sentry-source-file="UploadTypeSelectionCard.tsx">
        <button className={S.upload_button}>
          <img src={`/images/light/assetStore/${type}_upload_thumbnail.png`} width={148} height={148} className={S.card_image} alt={type} />
        </button>
      </Link>
      <div className={S.card_text}>
        {t('store:store_upload_something', {
        x: t(titleKey)
      })}
      </div>
    </div>;
};
export default UploadTypeSelectionCard;
type UploadTypeSelectionCardProps = {
  type: string;
  titleKey: ParseKeys<['store']>;
};